import ModalDesembolsar from '../components/ModalDesembolsar.vue';
import VerPdf from '../components/VerPdf.vue';
import {
  ESTADOS_DETALLE_SOLICITUD,
  ESTADOS_SOLICITUD,
  ID_SEDE_GRUPO_CORPORATIVO,
  TIPOS_CUENTAS_BANCARIAS,
  establecerRangoFechas,
  formatearCuentas,
  getSedesPortal,
  getUnidadesNegocio,
  obtenerColorEstadoDetalleSolicitud,
  obtenerTodasLasSedes,
  peticionCuentas1,
  peticionCuentas2,
} from '../utils';
import SolicitudRecursosServices from '../services/solicitud';
import DetallesSolicitudService from '../services/detalle-solicitud';
import { mapGetters } from 'vuex';
import ReportesExcelService from '../services/reportes-excel';
import DescargarExcelMixin from '../mixins/descargar-excel.mixin';
import configuraciones from '../services/configuraciones';

export default {
  components: {
    ModalDesembolsar,
    VerPdf,
  },
  mixins: [DescargarExcelMixin],
  data() {
    return {
      cargando: false,
      items: [],
      item: [],
      deshabilitarBotonEditar: true,
      deshabilitarBotonAprobar: true,
      deshabilitarBotonDesembolsar: true,
      deshabilitarBotonRegistrarPagos: true,
      searchQuery: null,
      itemsFiltroEstadoSolicitud: [
        { text: ESTADOS_SOLICITUD.TODOS, value: ESTADOS_SOLICITUD.TODOS },
        { text: ESTADOS_SOLICITUD.SOLICITADO, value: ESTADOS_SOLICITUD.SOLICITADO },
        { text: ESTADOS_SOLICITUD.ATENDIDO, value: ESTADOS_SOLICITUD.ATENDIDO },
      ],
      itemsFiltroEstadoDetalleSolicitud: Object.values(ESTADOS_DETALLE_SOLICITUD).filter(
        (estado) => estado != ESTADOS_DETALLE_SOLICITUD.TODOS,
      ),
      rangoFechas: [this.fechaDeHoy(), this.fechaDeHoy()],
      fechaInicio: null,
      fechaFin: null,
      menuFechaDeSolicitud: false,
      rangoFechasDesembolso: [this.fechaDeHoy(), this.fechaDeHoy()],
      fechaInicioDesembolso: null,
      fechaFinDesembolso: null,
      menuFechaDeDesembolso: false,
      sedes: [],
      unidadesNegocio: [],
      unidadNegocioId: null,
      fnDescarga: null,
      mostradoGenerarConciliacion: false,
      sedesItems: [],
      cuentasItems: [],
      sedeSeleccionada: null,
      formConciliacion: {
        id_sede_seleccionada: null,
        fecha_inicio_desembolso: null,
        fecha_fin_desembolso: null,
        cuenta_como: null,
        numeros_cuentas: [],
      },
      cuentasSeleccionadas: [],
      cuentasComoItems: [
        { text: 'Origen', value: 'origen' },
        { text: 'Destino', value: 'destino' },
      ],
      menuFechaDeDesembolsoReporteConciliacion: false,
      rangoFechasDesembolsoReporteConciliacion: [this.fechaDeHoy(), this.fechaDeHoy()],
      metadatos: null,
      limite: Number(localStorage.getItem('limitePaginacion')) || 10,
      pagina: 1,
      retraso: null,
      cargandoVerPdf: false,
      cargandoVerPdfTodos: false,
      cargandoVerPdfTodosConsolidadoSubtotales: false,
      cargandoVerPdfTodosConsolidadoPorCuentaOrigen: false,
    };
  },
  mounted() {
    Promise.all([this.getSedes(), this.getUnidadesNegocio()]).then(() => {
      this.listar();
    });
  },
  watch: {
    rangoFechas: function (value) {
      if (!value) {
        this.fechaInicio = null;
        this.fechaFin = null;

        this.listar();
      }
    },
    rangoFechasDesembolso: function (value) {
      if (!value) {
        this.fechaInicioDesembolso = null;
        this.fechaFinDesembolso = null;

        this.listar();
      }
    },
  },
  computed: {
    ...mapGetters({
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
      permisosPresupuestos3: 'presupuesto/permisosPresupuestos3',
    }),
    deshabilitadoRangoFechasDesembolso() {
      return (
        this.estadosSeleccionadosDetalleSolicitud.length != 1 ||
        this.estadosSeleccionadosDetalleSolicitud[0] != ESTADOS_DETALLE_SOLICITUD.DESEMBOLSADO
      );
    },
    sedesSeleccionadasIds() {
      const SEDES_POR_USUARIO_ID = {
        31: [
          // ANDREA ZUÑIGA YAÑEZ
          1, // Esam Tarija 1
          2, // Esam Tarija 2
          3, // Esam Sucre
          4, // Esam Potosí
          5, // Esam Santa Cruz
          6, // Esam Yacuiba
          7, // Esam Camargo
          8, // Esam Cochabamba
          9, // Cca Sucre
          10, // Cca Tarija Central
          11, // Ciberkids Santa Cruz
          12, // Ciberkids Sucre
          13, // Ciberkids Tarija
          14, // Esam La Paz
          15, // Esam Santa Cruz Sucursal
          16, // Esam Latam
          17, // Colegio Aleman Del Sud
          18, // Esam Monteagudo
          19, // Benito Juarez
          20, // Esam Sucre Sucursal
          21, // Cybercorp Academy Nacional
          22, // Esam La Paz Sucursal
          23, // Esam Cochabamba Sucursal
          24, // Digital School Cobija
          25, // Esam Oruro
          26, // Esam Potosí Sucursal
          27, // Digital School Tarija
          28, // Digital School Sucre
          29, // Digital School Potosi
          30, // Digital School La Paz
          31, // Digital School Cochabamba
          32, // Digital School Latam
          33, // Digital School Santa Cruz
          34, // Cybercorp Academy Camargo
          35, // Cybercorp Academy Monteagudo
          36, // Cybercorp Academy Tarija
          37, // Esam Tarija 3
          39, // C.c. Tec. Priv. Sucre
          40, // Cybercorp Academy Potosí
          41, // Spa Car
          42, // Digital School Monteagudo
          43, // New Center
          44, // Cybercorp Siesam
          45, // Dirección Nacional de Formación Continua
          47, // Ciberkids Tarija Sucursal
          48, // Cca Tarija Sucursal
          50, // Esam El Alto
          51, // Esam Cochabamba 3
          52, // Esam Latam 2
          53, // Digital School Sucre Sucursal
          79, // Cca Potosi
          80, // Esam Tarija 4
          81, // Ciberkids Kinder
          83, // Building Corp
          84, // Fenix Cars
          85, // Dream World
        ],
        870: [
          // NATALY SORUCO SÁNCHEZ
          1, // Esam Tarija 1 - Por vacaciones de Andrea Zuñiga Yañez
          2, // Esam Tarija 2
          5, // Esam Santa Cruz
          6, // Esam Yacuiba
          7, // Esam Camargo
          10, // Cca Tarija Central
          13, // Ciberkids Tarija
          15, // Esam Santa Cruz Sucursal
          16, // Esam Latam
          17, // Colegio Aleman Del Sud
          37, // Esam Tarija 3 - Por vacaciones de Andrea Zuñiga Yañez
          47, // Ciberkids Tarija Sucursal
          48, // Cca Tarija Sucursal
          49, // Instituto Superior Politécnico Internacional
          80, // Esam Tarija 4 - Por vacaciones de Andrea Zuñiga Yañez
          83, // Building Corp
          84, // Fenix Cars
          85, // Dream World
          101, // Paraguay Tarija 2
          107, // Digital School Camargo
        ],
        6457: [
          // HOMALY TEYBE ZAMORANO DURAN
          1, // Esam Tarija 1
          2, // Esam Tarija 2
          3, // Esam Sucre
          4, // Esam Potosí
          5, // Esam Santa Cruz
          6, // Esam Yacuiba
          7, // Esam Camargo
          8, // Esam Cochabamba
          9, // Cca Sucre
          10, // Cca Tarija Central
          11, // Ciberkids Santa Cruz
          12, // Ciberkids Sucre
          13, // Ciberkids Tarija
          14, // Esam La Paz
          15, // Esam Santa Cruz Sucursal
          16, // Esam Latam
          17, // Colegio Aleman Del Sud
          18, // Esam Monteagudo
          19, // Benito Juarez
          20, // Esam Sucre Sucursal
          21, // Cybercorp Academy Nacional
          22, // Esam La Paz Sucursal
          23, // Esam Cochabamba Sucursal
          24, // Digital School Cobija
          25, // Esam Oruro
          26, // Esam Potosí Sucursal
          27, // Digital School Tarija
          28, // Digital School Sucre
          29, // Digital School Potosi
          30, // Digital School La Paz
          31, // Digital School Cochabamba
          32, // Digital School Latam
          33, // Digital School Santa Cruz
          34, // Cybercorp Academy Camargo
          35, // Cybercorp Academy Monteagudo
          36, // Cybercorp Academy Tarija
          37, // Esam Tarija 3
          39, // C.c. Tec. Priv. Sucre
          40, // Cybercorp Academy Potosí
          41, // Spa Car
          42, // Digital School Monteagudo
          43, // New Center
          44, // Cybercorp Siesam
          45, // Dirección Nacional de Formación Continua
          47, // Ciberkids Tarija Sucursal
          48, // Cca Tarija Sucursal
          50, // Esam El Alto
          51, // Esam Cochabamba 3
          52, // Esam Latam 2
          53, // Digital School Sucre Sucursal
          79, // Cca Potosi
          80, // Esam Tarija 4
          81, // Ciberkids Kinder
          84, // Fenix Cars
          107, // Digital School Camargo
          125, // Esam DBS Sucre
          127, // Esam Dbs Cobija
          128, // Esam Dbs Cochabamba
          129, // Esam Dbs Tarija
        ],
        46812: [
          // MARIELA TORRES TORRES
          14, // Esam La Paz
          25, // Esam Oruro
          31, // Digital School Cochabamba
          32, // Digital School Latam
          39, // C.c. Tec. Priv. Sucre
          45, // Dirección Nacional de Formación Continua
          49, // Instituto Superior Politécnico Internacional
          50, // Esam El Alto
          52, // Esam Latam 2
          54, // ISPI Tarija 1
          55, // ISPI Tarija 2
          56, // ISPI Tarija 3
          57, // ISPI Cochabamba
          58, // ISPI Cochabamba Sucursal
          59, // ISPI La Paz
          60, // ISPI La Paz Sucursal
          61, // ISPI Santa Cruz
          62, // ISPI Santa Cruz Sucursal
          63, // ISPI Monteagudo
          64, // ISPI Oruro
          65, // ISPI Potosí
          66, // ISPI Sucre
          67, // ISPI Sucre Sucursal
          68, // ISPI Camargo
          69, // ISPI Yacuiba
          70, // ISPI Latam
          71, // ISPI Latam 2
          72, // ISPI Digital School Cochabamba
          73, // ISPI Digital School Sucre
          74, // ISPI Digital School Sucre Sucursal
          75, // ISPI Digital School Cobija
          76, // ISPI Digital School Tarija
          77, // ISPI Digital School Potosi
          78, // ISPI Cybercorp Academy
          82, // Universidad Politécnica Internacional
          86, // UPI La Paz Central
          87, // UPI La Paz Sucursal
          88, // UPI Santa Cruz Central
          89, // UPI Santa Cruz Sucursal
          90, // UPI Cochabamba Sucursal
          91, // UPI Cochabamba Central
          92, // UPI Tarija Central
          93, // UPI Tarija Sucursal
          94, // UPI Tarija 3
          95, // UPI Camargo
          96, // UPI Sucre Central
          97, // UPI Sucre Sucursal
          98, // UPI Yacuiba
          99, // UPI DBS Tarija
          100, // UPI DBS Cobija
          128, // Esam Dbs Cochabamba
        ],
        52394: [
          // JHOMARA JAEL GALARZA CRUZ
          4, // Esam Potosí
          18, // Esam Monteagudo
          21, // Cybercorp Academy Nacional
          24, // Digital School Cobija
          30, // Digital School La Paz
          36, // Cybercorp Academy Tarija
          41, // Spa Car
          42, // Digital School Monteagudo
          43, // New Center
          79, // Cca Potosi
          127, // Esam Dbs Cobija
        ],
        54960: [
          // CAMILA MENDIVIL PAREDES
          9, // Cca Sucre
          18, // Esam Monteagudo
          27, // Digital School Tarija
          28, // Digital School Sucre
          29, // Digital School Potosi
          39, // C.c. Tec. Priv. Sucre
          53, // Digital School Sucre Sucursal
          125, // Esam DBS Sucre
          129, // Esam Dbs Tarija
        ],
        18491: [
          // GISELA CARVAJAL NINAJA
          13, // Ciberkids Tarija
          17, // Colegio Aleman Del Sud
          47, // Ciberkids Tarija Sucursal
        ],
        89251: [
          // BAPTISTA ALBORNOZ ANDREA MILENKA
          12, // Ciberkids Sucre
          39, // C.c. Tec. Priv. Sucre
          41, // Spa Car
        ],
        8920: [
          // FABIOLA AVILA RODRÍGUEZ
          21, // Cybercorp Academy Nacional
          27, // Digital School Tarija
          29, // Digital School Potosi
          34, // Cybercorp Academy Camargo
          35, // Cybercorp Academy Monteagudo
          36, // Cybercorp Academy Tarija
          40, // Cybercorp Academy Potosí
          41, // Spa Car
          44, // Cybercorp Siesam
          49, // Instituto Superior Politécnico Internacional
          82, // Universidad Politécnica Internacional
        ],
        9029: [
          // GARDILCIC FLORES DINKA RAHIZA
          1, // Esam Tarija 1
          2, // Esam Tarija 2
          3, // Esam Sucre
          4, // Esam Potosí
          5, // Esam Santa Cruz
          6, // Esam Yacuiba
          7, // Esam Camargo
          8, // Esam Cochabamba
          9, // Cca Sucre
          10, // Cca Tarija Central
          11, // Ciberkids Santa Cruz
          12, // Ciberkids Sucre
          13, // Ciberkids Tarija
          14, // Esam La Paz
          15, // Esam Santa Cruz Sucursal
          16, // Esam Latam
          17, // Colegio Aleman Del Sud
          18, // Esam Monteagudo
          19, // Benito Juarez
          20, // Esam Sucre Sucursal
          21, // Cybercorp Academy Nacional
          22, // Esam La Paz Sucursal
          23, // Esam Cochabamba Sucursal
          24, // Digital School Cobija
          25, // Esam Oruro
          26, // Esam Potosí Sucursal
          27, // Digital School Tarija
          28, // Digital School Sucre
          29, // Digital School Potosi
          30, // Digital School La Paz
          31, // Digital School Cochabamba
          32, // Digital School Latam
          33, // Digital School Santa Cruz
          34, // Cybercorp Academy Camargo
          35, // Cybercorp Academy Monteagudo
          36, // Cybercorp Academy Tarija
          37, // Esam Tarija 3
          39, // C.c. Tec. Priv. Sucre
          40, // Cybercorp Academy Potosí
          47, // Ciberkids Tarija Sucursal
          48, // Cca Tarija Sucursal
          49, // Instituto Superior Politécnico Internacional
          50, // Esam El Alto
          52, // Esam Latam 2
          79, // Cca Potosi
          80, // Esam Tarija 4
          82, // Universidad Politécnica Internacional
          101, // Paraguay Tarija 2
        ],
      };

      const sedesPorUsuario = SEDES_POR_USUARIO_ID[this.$store.state.DATA_USER.id];

      if (sedesPorUsuario) {
        return this.sedes
          .filter((sede) => sede.unidad_negocio == this.unidadNegocioId && sedesPorUsuario.includes(sede.id))
          .map((sede) => sede.id);
      }

      return this.sedes.filter((sede) => sede.unidad_negocio == this.unidadNegocioId).map((sede) => sede.id);
    },
    deshabilitadoBotonGenerarReporteConciliacion() {
      return (
        this.sedeSeleccionada == null ||
        this.rangoFechasDesembolsoReporteConciliacion?.length != 2 ||
        this.cuentasSeleccionadas.length == 0 ||
        this.formConciliacion.cuenta_como == null
      );
    },
    unidadesNegocioFiltradas() {
      const ESAM = 1;
      const CCA = 2;
      const CK = 3;
      const CAST = 4;
      const ESAM_LATAM = 5;
      const CYBERCORP = 6;
      const DBS = 10;
      // const WORLD_OF_BUSINESS_IDEAS = 11;
      const CCTP = 12;
      const NEW_CENTER = 13;
      const ISPI = 14;
      const UPI = 15;
      const FENIX_CARS = 16;
      const BUILDING_CORP = 17;
      const DREAM_WORLD = 18;
      const ESAM_LATAM_PARAGUAY = 19;

      if (this.$store.state.DATA_USER.id == 31) {
        // ANDREA ZUÑIGA YAÑEZ
        return this.unidadesNegocio.filter((unidad) =>
          [
            ESAM,
            CCA,
            CK,
            CAST,
            ESAM_LATAM,
            CYBERCORP,
            DBS,
            CCTP,
            NEW_CENTER,
            FENIX_CARS,
            BUILDING_CORP,
            DREAM_WORLD,
          ].includes(unidad.id),
        );
      }

      if (this.$store.state.DATA_USER.id == 870) {
        // NATALY SORUCO SÁNCHEZ
        return this.unidadesNegocio.filter((unidad) =>
          [
            ESAM,
            CCA,
            CK,
            CAST,
            ESAM_LATAM,
            DBS,
            ISPI,
            FENIX_CARS,
            BUILDING_CORP,
            DREAM_WORLD,
            ESAM_LATAM_PARAGUAY,
          ].includes(unidad.id),
        );
      }

      if (this.$store.state.DATA_USER.id == 6457) {
        // HOMALY TEYBE ZAMORANO DURAN
        return this.unidadesNegocio.filter((unidad) =>
          [ESAM, CCA, CK, CAST, ESAM_LATAM, CYBERCORP, DBS, CCTP, NEW_CENTER, FENIX_CARS].includes(unidad.id),
        );
      }

      if (this.$store.state.DATA_USER.id == 46812) {
        // MARIELA TORRES TORRES
        return this.unidadesNegocio.filter((unidad) => [ESAM, ESAM_LATAM, DBS, CCTP, ISPI, UPI].includes(unidad.id));
      }

      if (this.$store.state.DATA_USER.id == 52394) {
        // JHOMARA JAEL GALARZA CRUZ
        return this.unidadesNegocio.filter((unidad) => [ESAM, CCA, CYBERCORP, DBS, NEW_CENTER].includes(unidad.id));
      }

      if (this.$store.state.DATA_USER.id == 54960) {
        // CAMILA MENDIVIL PAREDES
        return this.unidadesNegocio.filter((unidad) => [ESAM, CCA, DBS, CCTP].includes(unidad.id));
      }

      if (this.$store.state.DATA_USER.id == 18491) {
        // GISELA CARVAJAL NINAJA
        return this.unidadesNegocio.filter((unidad) => [CK, CAST].includes(unidad.id));
      }

      if (this.$store.state.DATA_USER.id == 89251) {
        // BAPTISTA ALBORNOZ ANDREA MILENKA
        return this.unidadesNegocio.filter((unidad) => [CK, CYBERCORP, CCTP].includes(unidad.id));
      }

      if (this.$store.state.DATA_USER.id == 8920) {
        // FABIOLA AVILA RODRÍGUEZ
        return this.unidadesNegocio.filter((unidad) => [CYBERCORP, DBS, ISPI, UPI].includes(unidad.id));
      }

      if (this.$store.state.DATA_USER.id == 9029) {
        // GARDILCIC FLORES DINKA RAHIZA
        return this.unidadesNegocio.filter((unidad) =>
          [ESAM, CCA, CK, CAST, ESAM_LATAM, CYBERCORP, DBS, CCTP, ISPI, ESAM_LATAM_PARAGUAY].includes(unidad.id),
        );
      }

      return this.unidadesNegocio;
    },
  },
  methods: {
    async verPdf(id) {
      this.pdf = null;
      this.cargandoVerPdf = true;

      try {
        const response = await SolicitudRecursosServices.reporte(id);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const pdf = URL.createObjectURL(blob);

        this.$refs.verPdf.abrir(pdf);
      } catch (err) {
        window.console.log(err);
      } finally {
        this.cargandoVerPdf = false;
      }
    },
    async verPdfTodosMixin(params) {
      this.pdf = null;
      this.cargandoVerPdfTodos = true;

      try {
        const response = await SolicitudRecursosServices.reporteTodos(params);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const pdf = URL.createObjectURL(blob);

        this.fnDescarga = () => this.descargarExcel(ReportesExcelService.solicitudesReporteTodos, null, { params });

        this.$refs.verPdf.abrir(pdf);
      } catch (err) {
        window.console.log(err);
      } finally {
        this.cargandoVerPdfTodos = false;
      }
    },
    async verPdfTodosConsolidadoMixin(params) {
      this.pdf = null;
      try {
        const response = await SolicitudRecursosServices.reporteTodosConsolidado(params);
        const pdf = `data:application/pdf;base64,${response.data.datos}`;

        this.$refs.verPdf.abrir(pdf);
      } catch (err) {
        window.console.log(err);
      }
    },
    async verPdfTodosConsolidadoSubtotalesMixin(params) {
      this.pdf = null;
      this.cargandoVerPdfTodosConsolidadoSubtotales = true;

      try {
        const response = await SolicitudRecursosServices.reporteTodosConsolidadoSubtotales(params);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const pdf = URL.createObjectURL(blob);

        this.fnDescarga = () =>
          this.descargarExcel(ReportesExcelService.solicitudesReporteConsolidadoSubtotales, null, { params });

        this.$refs.verPdf.abrir(pdf);
      } catch (err) {
        window.console.log(err);
      } finally {
        this.cargandoVerPdfTodosConsolidadoSubtotales = false;
      }
    },
    async verPdfTodosConsolidadoPorCuentaOrigenMixin(params) {
      this.pdf = null;
      this.cargandoVerPdfTodosConsolidadoPorCuentaOrigen = true;

      try {
        const response = await SolicitudRecursosServices.reporteTodosConsolidadoPorCuentaOrigen(params);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const pdf = URL.createObjectURL(blob);

        this.fnDescarga = () =>
          this.descargarExcel(ReportesExcelService.solicitudesReporteConsolidadoPorCuentaOrigen, null, { params });

        this.$refs.verPdf.abrir(pdf);
      } catch (err) {
        window.console.log(err);
      } finally {
        this.cargandoVerPdfTodosConsolidadoPorCuentaOrigen = false;
      }
    },
    async listarMixin(params) {
      this.cargando = true;
      try {
        const response = await SolicitudRecursosServices.get(params);

        this.items = response.data.datos;
        this.metadatos = response.data?.metadatos;
        this.item = null;
        this.deshabilitarBotonEditar = true;
        this.deshabilitarBotonAprobar = true;
        this.deshabilitarBotonDesembolsar = true;
        this.deshabilitarBotonRegistrarPagos = true;
      } catch (err) {
        window.console.log(err);
      } finally {
        this.cargando = false;
      }
    },
    selectItem(item) {
      const deshabilitarEditar = item.detalle_solicitud.some((detalle) => {
        return (
          detalle.estado === ESTADOS_DETALLE_SOLICITUD.DESEMBOLSADO ||
          detalle.estado === ESTADOS_DETALLE_SOLICITUD.APROBADO ||
          detalle.estado === ESTADOS_DETALLE_SOLICITUD.RECHAZADO ||
          detalle.estado === ESTADOS_DETALLE_SOLICITUD.ANULADO ||
          detalle.estado === ESTADOS_DETALLE_SOLICITUD.PAGADO ||
          detalle.estado === ESTADOS_DETALLE_SOLICITUD.PAGADO_PARCIALMENTE ||
          detalle.estado === ESTADOS_DETALLE_SOLICITUD.REVERSION
        );
      });

      const deshabilitarDesembolsar = item.detalle_solicitud.every(
        (detalle) =>
          detalle.estado === ESTADOS_DETALLE_SOLICITUD.DESEMBOLSADO ||
          detalle.estado !== ESTADOS_DETALLE_SOLICITUD.APROBADO,
      );

      const deshabilitarAprobar = item.detalle_solicitud.every(
        (detalle) =>
          detalle.estado === ESTADOS_DETALLE_SOLICITUD.DESEMBOLSADO ||
          detalle.estado === ESTADOS_DETALLE_SOLICITUD.RECHAZADO,
      );

      const deshabilitarRegistrarPagos = item.detalle_solicitud.every(
        (detalle) =>
          detalle.estado !== ESTADOS_DETALLE_SOLICITUD.DESEMBOLSADO &&
          detalle.estado !== ESTADOS_DETALLE_SOLICITUD.PAGADO_PARCIALMENTE &&
          detalle.estado !== ESTADOS_DETALLE_SOLICITUD.PAGADO,
      );

      this.item = item;
      this.deshabilitarBotonEditar = deshabilitarEditar;
      this.deshabilitarBotonAprobar = deshabilitarAprobar;
      this.deshabilitarBotonDesembolsar = deshabilitarDesembolsar;
      this.deshabilitarBotonRegistrarPagos = deshabilitarRegistrarPagos;
    },
    updateSearchQuery(val) {
      this.$refs.listadoRef.updateSearchQuery(val);
    },
    obtenerColorEstadoDetalleSolicitud(estado) {
      return obtenerColorEstadoDetalleSolicitud(estado);
    },
    removerEstadoSeleccionado(itemEstado) {
      this.estadosSeleccionadosDetalleSolicitud.splice(
        this.estadosSeleccionadosDetalleSolicitud.indexOf(itemEstado),
        1,
      );
    },
    fechaDeHoy() {
      const hoy = new Date();
      const mes = hoy.getMonth() + 1;
      const dia = hoy.getDate();
      const anio = hoy.getFullYear();

      const mesString = mes < 10 ? `0${mes}` : mes;
      const diaString = dia < 10 ? `0${dia}` : dia;

      return `${anio}-${mesString}-${diaString}`;
    },
    establecerRangoFechasConsulta() {
      if (this.rangoFechas?.length == 2) {
        const fecha1 = this.rangoFechas[0];
        const fecha2 = this.rangoFechas[1];
        const { fechaInicio, fechaFin } = establecerRangoFechas(fecha1, fecha2);

        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;

        this.menuFechaDeSolicitud = false;
      } else {
        this.fechaInicio = null;
        this.fechaFin = null;
      }
    },
    establecerRangoFechasConsultaDesembolso() {
      if (this.rangoFechasDesembolso?.length == 2) {
        const fecha1 = this.rangoFechasDesembolso[0];
        const fecha2 = this.rangoFechasDesembolso[1];
        const { fechaInicio, fechaFin } = establecerRangoFechas(fecha1, fecha2);

        this.fechaInicioDesembolso = fechaInicio;
        this.fechaFinDesembolso = fechaFin;

        this.menuFechaDeDesembolso = false;
      } else {
        this.fechaInicioDesembolso = null;
        this.fechaFinDesembolso = null;
      }
    },
    async getSedes() {
      try {
        const respuesta = await getSedesPortal(this.$apollo);

        this.sedes = respuesta.data.getSedes;
      } catch (error) {
        window.console.log(error);
      }
    },
    async getUnidadesNegocio() {
      try {
        const respuesta = await getUnidadesNegocio(this.$apollo);

        this.unidadesNegocio = respuesta.data.NegociosAll;

        if (this.unidadesNegocioFiltradas.length == this.unidadesNegocio.length) {
          this.unidadNegocioId = null;
        } else {
          this.unidadNegocioId = this.unidadesNegocioFiltradas[0].id;
        }
      } catch (error) {
        window.console.log(error);
      }
    },
    async getTodasLasSedes() {
      try {
        const [respuestaUsuariosIdsAutorizadosSedeGrupoCorporativo, sedesTodas] = await Promise.all([
          configuraciones.idsUsuariosAutorizadosParaSedeGrupoCorporativo(),
          obtenerTodasLasSedes(this.$apollo),
        ]);
        const idsUsuariosAutorizados =
          respuestaUsuariosIdsAutorizadosSedeGrupoCorporativo?.data?.datos?.map((item) => item.id) || [];

        if (!idsUsuariosAutorizados.includes(this.$store.state.DATA_USER.id)) {
          this.sedesItems = sedesTodas.filter((sede) => sede.id != ID_SEDE_GRUPO_CORPORATIVO);
        } else {
          this.sedesItems = sedesTodas;
        }
      } catch (error) {
        window.console.log(error);
      }
    },
    async abrirModalGenerarReporteConciliacion() {
      this.mostradoGenerarConciliacion = true;

      await this.getTodasLasSedes();
    },
    async obtenerCuentas() {
      const id = this.sedeSeleccionada.id;
      this.cuentasSeleccionadas = [];
      this.cuentasItems = [];

      try {
        const [cuentas1, cuentas2] = await Promise.all([peticionCuentas1(id), peticionCuentas2(id, this.$apollo)]);
        const cuentas1Formateado = cuentas1?.data?.datos?.map(formatearCuentas(TIPOS_CUENTAS_BANCARIAS.PAGADORA));
        const cuentas2Formateado = cuentas2?.data?.getSede?.cuentasBancarias
          ? cuentas2?.data?.getSede?.cuentasBancarias?.map(formatearCuentas(TIPOS_CUENTAS_BANCARIAS.RECAUDADORA))
          : [];

        this.cuentasItems = [...cuentas1Formateado, ...cuentas2Formateado];
      } catch (error) {
        window.console.log(error);

        this.cuentasItems = [];
      }
    },
    removerCuentaSeleccionada(itemCuenta) {
      this.cuentasSeleccionadas.splice(this.cuentasSeleccionadas.indexOf(itemCuenta), 1);
    },
    async verPdfReporteConciliacion() {
      try {
        const [fecha1, fecha2] = this.rangoFechasDesembolsoReporteConciliacion;
        const { fechaInicio, fechaFin } = establecerRangoFechas(fecha1, fecha2);

        this.formConciliacion.id_sede_seleccionada = this.sedeSeleccionada.id;
        this.formConciliacion.fecha_inicio_desembolso = fechaInicio;
        this.formConciliacion.fecha_fin_desembolso = fechaFin;
        this.formConciliacion.numeros_cuentas = this.cuentasSeleccionadas.map((cuenta) => cuenta.nro);

        const params = this.formConciliacion;
        const idSede = this.formConciliacion.id_sede_seleccionada;
        const { data } = await DetallesSolicitudService.conciliacionPorSede(idSede, { params });
        const blob = new Blob([data], { type: 'application/pdf' });
        const pdf = URL.createObjectURL(blob);

        this.fnDescarga = () => this.descargarExcel(ReportesExcelService.conciliacionPorSede, idSede, { params });

        this.$refs.verPdf.abrir(pdf);
      } catch (error) {
        window.console.log(error);
      }
    },
    cerrarModalReporteConciliacion() {
      this.mostradoGenerarConciliacion = false;
      this.sedeSeleccionada = null;
      this.rangoFechasDesembolsoReporteConciliacion = [this.fechaDeHoy(), this.fechaDeHoy()];
      this.cuentasSeleccionadas = [];
      this.formConciliacion = {
        id_sede_seleccionada: null,
        fecha_inicio_desembolso: null,
        fecha_fin_desembolso: null,
        numeros_cuentas: [],
      };
    },
    listarRestableciendoPagina() {
      if (this.pagina != 1) {
        this.pagina = 1;
      }

      this.listar();
    },
    cambiarPagina() {
      this.listarRestableciendoPagina();

      localStorage.setItem('limitePaginacion', this.limite);
    },
    updateSearchQueryBack() {
      clearTimeout(this.retraso);

      this.retraso = setTimeout(() => {
        this.listarRestableciendoPagina();
      }, 500);
    },
  },
};
